import $ from 'jquery';

import cssClasses from '../helpers/cssClasses';
import karmoonSelect from '../components/karmoon-select';

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-product-swatches="container"]',
  productJson: '[data-product-json]',
  inventoryJson: '[data-inventory-json]',
  singleOptionSelect: '[data-single-option-selector]',
  swatchTitleContainer: '[js-product-swatches="swatchTitleContainer"]',
};

/**
 * Export default AjaxCart.
 */
export default (config) => {
  const container = document.querySelector(`${config.container}`);

  const nodeSelectors = {
    container: container.querySelectorAll(selectors.container),
    productJson: container.querySelector(selectors.productJson),
    inventoryJson: container.querySelector(selectors.inventoryJson),
    singleOptionSelect: container.querySelectorAll(
      selectors.singleOptionSelect,
    ),
    swatchTitleContainer: container.querySelector(
      selectors.swatchTitleContainer,
    ),
  };

  function init() {
    nodeSelectors.container.forEach((element) => {
      element.addEventListener('click', handleClick);
      element.addEventListener('click', swatchChange);
    });

    nodeSelectors.singleOptionSelect.forEach((element) => {
      element.addEventListener('change', singleSelectorTrigger);
    });

    Karmoon.EventBus.listen('Swatch:updated', (element) => {
      window.setTimeout(() => {
        updateSwatchTitle(element);
      });
    });
  }

  function handleClick(element) {
    const {target} = element;

    Karmoon.EventBus.emit('Swatch:updated', element.target);

    if (target.dataset.swatchOption === 'option1') {
      optionActive(target, 1);
      checkInventory(target);

      if (config.updateSlider === true) {
        updateSlider(target);
      }
    }

    if (target.dataset.swatchOption === 'option2') {
      optionActive(target, 2);
      checkInventory(target);
    }

    if (target.dataset.swatchOption === 'option3') {
      optionActive(target, 3);
      checkInventory(target);
    }
  }

  function getProductJSON() {
    return JSON.parse(nodeSelectors.productJson.innerHTML);
  }

  function getVariants() {
    const productJSON = getProductJSON();
    return productJSON.variants;
  }

  function getCurrentSelected(value) {
    const option = container.querySelector(
      `[data-swatch-option="option${value}"].is-active`,
    );

    if (option === null) {
      return false;
    }
    const optionValue = option.dataset.swatchValue;
    return optionValue;
  }

  function checkInventory() {
    const currentOption1 = getCurrentSelected(1);
    const currentOption2 = getCurrentSelected(2);
    const currentOption3 = getCurrentSelected(3);
    const inventory = getVariants();

    setSwatchesToUnavailable();

    inventory.forEach((variant) => {
      if (currentOption1 === variant.option1) {
        if (currentOption3 !== false) {
          if (currentOption3 === variant.option3) {
            updateOption2(variant);
          }
        } else if (currentOption2 !== false) {
          updateOption2(variant);
        }
      }

      if (
        currentOption1 === variant.option1 &&
        currentOption2 === variant.option2
      ) {
        if (currentOption3 !== false) {
          updateOption3(variant);
        }
      }
    });
  }

  function updateOption2(variant) {
    if (variant.available === false) {
      const target = container.querySelector(
        `[data-swatch-option="2"][data-swatch-value="${variant.option2}"]`,
      );
      setToUnavailable(target);
    } else {
      const target = container.querySelector(
        `[data-swatch-option="option2"][data-swatch-value="${variant.option2}"]`,
      );
      setToAvailable(target);
    }
  }

  function updateOption3(variant) {
    if (variant.available === false) {
      const target = container.querySelector(
        `[data-swatch-option="option3"][data-swatch-value="${variant.option3}"]`,
      );
      setToUnavailable(target);
    } else {
      const target = container.querySelector(
        `[data-swatch-option="option3"][data-swatch-value="${variant.option3}"]`,
      );
      setToAvailable(target);
    }
  }

  function setSwatchesToUnavailable() {
    nodeSelectors.container.forEach((element) => {
      setToUnavailable(element);
    });
  }

  function setToUnavailable(element) {
    // element.classList.add(cssClasses.disabled);
  }

  function setToAvailable(element) {
    element.classList.remove(cssClasses.disabled);
  }

  function optionActive(target, optionNumber) {
    container
      .querySelectorAll(`[data-swatch-option="option${optionNumber}"]`)
      .forEach((element) => {
        element.classList.remove(cssClasses.active);
      });
    target.classList.add(cssClasses.active);
  }

  function swatchChange() {
    const $this = $(this);
    const swatchValue = $this.attr('data-swatch-value');
    const swatchOption = $this.attr('data-swatch-option');

    $(`${config.container} [data-index="${swatchOption}"]`)
      .val(swatchValue)
      .trigger('change');

    $('.karmoon--btn-select').removeClass('not-value');

    const swatchHash = `variant-${swatchValue
      .toLowerCase()
      .replace(/ /g, '-')}`;
    // console.log(swatchHash);

    Karmoon.EventBus.emit('variantChanged:changed', swatchHash);
  }

  function updateSlider(target) {
    const swatchValue = target.dataset.slider;

    $('.product-images__container').removeClass(cssClasses.active);
    $(`#${swatchValue}`).addClass(cssClasses.active);
  }

  function singleSelectorTrigger(target) {
    const optionIndex = target.target.dataset.index;
    const value = target.target.value.toLowerCase().replace(/ /g, '-');

    container
      .querySelectorAll(`[data-swatch-option="${optionIndex}"]`)
      .forEach((element) => {
        element.classList.remove(cssClasses.active);

        if (element.classList.contains(`swatch-product--${value}`)) {
          element.classList.add(cssClasses.active);
          Karmoon.EventBus.emit('Swatch:updated', element);
        }
      });
  }

  function updateSwatchTitle(element) {
    const {swatchTitle} = element.dataset;
    nodeSelectors.swatchTitleContainer.innerHTML = swatchTitle;
  }

  karmoonSelect();

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};